import { useState, useContext, useEffect } from 'react';
import { useForm } from '../../hooks';

import { Typography, Button, Grid, IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

import StyledModal from './StyledModal';
import { TextField, Button as StyledButton } from '../common';
import colors from '../../assets/colors';
import { farm } from '../../utils/api';
import FarmContext from '../../store/farm-context';

export default function EditFarmModal(props) {
  const farmCTX = useContext(FarmContext);
  const [formValid, setFormValid] = useState(false);

  const handleClose = () => props.setOpen(false);
  const handleDeleteFarm = () => {
    deleteFarm(props.farm.id);
    handleClose();
  };
  const handleEditFarm = () => {
    editFarm(props.farm.id);
    handleClose();
  };

  const { handleChange, handleChangeNumber, values } = useForm({
    address: props.farm?.address,
    arimr: props.farm?.arimr,
    farmName: props.farm?.farmName,
    name: props.farm?.name,
    nip: props.farm?.nip,
    pesel: props.farm?.pesel,
    surname: props.farm?.surname,
  });

  useEffect(() => {
    if (
      values.arimr?.length < 9 ||
      values.nip?.length < 10 ||
      values.pesel?.length < 11 ||
      values.farmName?.length === 0 ||
      values.name?.length === 0 ||
      values.surname?.length === 0 ||
      values.address?.length === 0
    )
      setFormValid(false);
    else setFormValid(true);
  }, [values]);

  const editFarm = (id) => {
    const body = {
      address: values.address ? values.address : props.farm?.address,
      arimr: values.arimr ? values.arimr : props.farm?.arimr,
      farmName: values.farmName ? values.farmName : props.farm?.farmName,
      name: values.name ? values.name : props.farm?.name,
      nip: values.nip ? values.nip : props.farm?.nip,
      pesel: values.pesel ? values.pesel : props.farm?.pesel,
      surname: values.surname ? values.surname : props.farm?.surname,
    };
    if (formValid)
      farm
        .edit(id, body)
        .then(() => props.update())
        .catch(() => {});
  };

  const deleteFarm = (id) => {
    farm
      .delete(id)
      .then(() => {
        if (id === farmCTX.farmID) {
          farmCTX.clearFarmID();
        }
        props.update();
      })
      .catch(() => {});
  };

  return (
    <StyledModal open={props.open}>
      <IconButton
        onClick={handleClose}
        sx={{
          color: colors.redButton,
          position: 'absolute',
          top: 5,
          right: 5,
        }}
      >
        <CancelIcon />
      </IconButton>
      <Grid container justifyContent="center">
        <Typography sx={{ fontSize: 36, fontWeight: 500, mb: 4, mt: 1 }}>
          Edytuj gospodarstwo
        </Typography>
      </Grid>
      <Grid container direction={'column'}>
        <Grid container>
          <TextField
            modal
            fullWidth
            label="Nazwa gospodarstwa"
            onChange={handleChange('farmName')}
            value={values.farmName}
            error={values.farmName?.length === 0}
            inputProps={{ maxLength: 48 }}
          />
        </Grid>
        <Grid container justifyContent="left">
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField
              modal
              label="Imię"
              onChange={handleChange('name')}
              value={values.name}
              inputProps={{ maxLength: 15 }}
              error={values.name?.length === 0}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField
              modal
              label="Nazwisko"
              onChange={handleChange('surname')}
              value={values.surname}
              inputProps={{ maxLength: 25 }}
              error={values.surname?.length === 0}
            />
          </Grid>
        </Grid>
        <Grid container>
          <TextField
            modal
            label="PESEL"
            value={values.pesel}
            onChange={handleChangeNumber('pesel')}
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
              maxLength: 11,
            }}
            error={values.pesel?.length < 11}
            helperText={
              values.pesel?.length < 11 && 'Numer PESEL składa się z 11 cyfr'
            }
          />
        </Grid>
        <Grid container justifyContent="left">
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField
              modal
              label="Numer identyfikacyjny ARIMR"
              value={values.arimr}
              onChange={handleChangeNumber('arimr')}
              inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
                maxLength: 9,
              }}
              error={values.arimr?.length < 9}
              helperText={
                values.arimr?.length < 9 && 'Numer ARIMR składa się z 9 cyfr'
              }
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField
              modal
              label="NIP"
              value={values.nip}
              onChange={handleChangeNumber('nip')}
              inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
                maxLength: 10,
              }}
              error={values.nip?.length < 10}
              helperText={values.nip?.length < 10 && 'NIP składa się z 10 cyfr'}
            />
          </Grid>
        </Grid>
        <Grid container>
          <TextField
            modal
            fullWidth
            label="Adres"
            onChange={handleChange('address')}
            value={values.address}
            error={values.address?.length === 0}
            inputProps={{
              maxLength: 200,
            }}
          />
        </Grid>

        {/* Delete button */}
        <Grid container justifyContent="space-between" sx={{ mt: 2 }}>
          <StyledButton
            red
            type="submit"
            variant="outlined"
            onClick={handleDeleteFarm}
          >
            Usuń
          </StyledButton>
          <Button
            type="submit"
            variant="outlined"
            onClick={handleEditFarm}
            disabled={!formValid}
          >
            Zapisz zmiany
          </Button>
        </Grid>
      </Grid>
    </StyledModal>
  );
}
